export default __webpack_public_path__ + "static/media/logo_sncf.3221f4cb.svg";